

export function HorizLineDivider({
  className,
  ...props
}) {

  return (
    <>
      <hr className={`w-full border-gray-300 ${className}`} />
      {/* <div className={`w-full border-b border-slate-200 ${className}`}></div> */}
    </>
  )
}